module.exports = __webpack_public_path__ + "media/images/game_icon/en/VGF01-fbc30ddf480e10dbde320b54d0926542.png";